module.exports = __webpack_public_path__ + "img/banner-590.15779982.png";